"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionServer = void 0;
const Paths_1 = require("./Paths");
class SubscriptionServer {
    constructor(httpService) {
        this.httpService = httpService;
    }
    acceptInvite(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpService.post(Paths_1.Paths.v1.acceptInvite(params.inviteUuid), params);
        });
    }
    declineInvite(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpService.get(Paths_1.Paths.v1.declineInvite(params.inviteUuid), params);
        });
    }
    cancelInvite(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpService.delete(Paths_1.Paths.v1.cancelInvite(params.inviteUuid), params);
        });
    }
    listInvites(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpService.get(Paths_1.Paths.v1.listInvites, params);
        });
    }
    invite(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpService.post(Paths_1.Paths.v1.invite, params);
        });
    }
    confirmAppleIAP(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpService.post(Paths_1.Paths.v1.confirmAppleIAP, params);
        });
    }
    getUserSubscription(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpService.get(Paths_1.Paths.v1.subscription(params.userUuid), params);
        });
    }
    getAvailableSubscriptions() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpService.get(Paths_1.Paths.v1.availableSubscriptions);
        });
    }
}
exports.SubscriptionServer = SubscriptionServer;
